import axios from 'axios';

export const loadConfig = async () => {
  try {
    // Always load from public folder
    const response = await axios.get(`${process.env.PUBLIC_URL}/config.json`, { cache: false });
    
    const env = process.env.NODE_ENV || 'development';
    console.log(`Loaded configuration for: ${env}`);

    if (response?.data?.[env]) {
      return response.data[env];
    } else {
      console.error('Invalid config.json format');
      return null;
    }
  } catch (error) {
    console.error('Error loading config.json:', error);
    return null;
  }
};
